import { Component, Input, OnInit } from '@angular/core';
import { TestataIntervento } from '../../models/Intervento';
import { Destinazione } from './../../models/Destinazione';
import { PreferencesService } from '../../sharedServices/preferences/preferences.service';

@Component({
  selector: 'app-popover-intervento',
  templateUrl: './popover-intervento.component.html',
  styleUrls: ['./popover-intervento.component.scss'],
})
export class PopoverInterventoComponent implements OnInit {
  @Input() model: TestataIntervento | Destinazione;
  @Input() isCliente: boolean;

  modalitaContattiRidotta = false;

  constructor(
    private preferencesService: PreferencesService
  ) { }

  async ngOnInit() {
    const preferenze = await this.preferencesService.getPreferenzeUtente();

    this.modalitaContattiRidotta = preferenze.MODCNTINT === '1';
  }

  get mostraIndirizzo(): boolean {
    return !this.modalitaContattiRidotta || !this.isCliente;
  }

  get mostraTelefonoEmail(): boolean {
    return !this.modalitaContattiRidotta || this.isCliente;
  }

  /**
   * Apre link telefonico
   */
  chiama() {
    if(this.model.telefono) {
      const telefono = this.model.telefono.replace(/ /g, ''); // Rimuovi eventuali spazi dal numero di telefono
      const url = 'tel:' + telefono;
      window.open(url, '_system');
    }
  }

  /**
   * Apre client di posta
   */
  inviaEmail() {
    if(this.model && this.model.mail) {
      let email = this.model.mail;
      let subject = encodeURIComponent("");
      let body = encodeURIComponent("");
      window.open(`mailto:${email}?subject=${subject}&body=${body}`, '_blank');
    }
  }
  
  /**
   * Apre link a gmaps.
   * Il link viene costruito utilizzando latitudine e longitudine.
   * Se questi dati non sono compilati, il link a GMaps viene determinato costruendo una query url con i dati del cliente
   * (indirizzo, cap, città, provincia).
   */
  apriGmaps() {
    const lat = Number(this.model.latitudine);
    const lng = Number(this.model.longitudine);

    if (lat && lng) {
      const geoUrlAddressCoordinate = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
      window.open(geoUrlAddressCoordinate, '_blank');
    } else {
      const geoUrlAddress = this.buildGeoQueryForCliente();
      if (geoUrlAddress)
        window.open(geoUrlAddress, '_blank');
    }
  }

  private buildGeoQueryForCliente(): string {
    const geoQueryElements = [];

    //Nome cliente
    // if (this.model.ragioneSociale) {
    //   geoQueryElements.push(this.model.ragioneSociale);
    // }
    //Indirizzo
    if (this.model.indirizzo) {
      geoQueryElements.push(this.model.indirizzo);
    }
    //CAP
    if (this.model.cap) {
      geoQueryElements.push(this.model.cap);
    }
    //Città
    if (this.model.citta) {
      geoQueryElements.push(this.model.citta);
    }
    //Provincia
    if (this.model.provincia) {
      geoQueryElements.push(this.model.provincia);
    }
    if (geoQueryElements.length) {
      const geoQueryPart = encodeURIComponent(geoQueryElements.join(','));
      return 'https://www.google.com/maps/search/?api=1&query=' + geoQueryPart;
    } else {
        return '';
    }
  }

  getAddress(): string{
    return `${this.model.indirizzo}, ${this.model.citta} (${this.model.provincia}) ${this.model.cap}`;
  }
}